import ModalFiltersAiNavigator from "./ModalFiltersAiNavigator";

export default ModalFiltersAiNavigator;